import { AuthProperty } from '../enums';

const AuthProps = {
  props: {
    [AuthProperty.Title]: {
      default: '',
      type: String,
    },
    [AuthProperty.TitleTooltip]: {
      default: '',
      type: String,
    },
    [AuthProperty.Legend]: {
      default: '',
      type: String,
    },
    [AuthProperty.IsShowSSO]: {
      default: false,
      type: Boolean,
    },
    [AuthProperty.IsShowNavLinks]: {
      default: false,
      type: Boolean,
    },
    [AuthProperty.IsBorderedNav]: {
      default: true,
      type: Boolean,
    },
    [AuthProperty.IsShowError]: {
      default: false,
      type: Boolean,
    },
    [AuthProperty.ErrorMessage]: {
      default: '',
      type: String,
    },
    [AuthProperty.SubmitLabel]: {
      default: '',
      type: String,
    },
    [AuthProperty.IsLoading]: {
      default: false,
      type: Boolean,
    },
    [AuthProperty.FooterLinks]: {
      default: () => [],
      type: Array,
    },
  },
};

export default AuthProps;
